import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { IOption } from '@cbridge-utils/options';
import { nodeStoreSelector } from '@cbridge-packages/node';
import { markupProfileListSelector } from '@cbridge-packages/markup-profile';

export const streamFormPropsSelector = createCachedSelector(
  [
    path(markupProfileListSelector).list(),
    path(nodeStoreSelector).list(),
    path(nodeStoreSelector).selected(),
  ],
  (markupProfileList, nodeList, selectedNodeId) => {
    const markupProfiles: IOption[] = markupProfileList
      .map(({ markupProfileId: value, markupProfileName: label }) => ({ value, label }));
    return {
      nodeList: nodeList.filter(({ nodeId }) => nodeId === selectedNodeId),
      markupProfiles,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
